import React, { useState, useEffect } from "react";
// styles
import "../pages.css";
// components
import Filtros from './Filtros';
// utils
import XGridDemo from "../../components/utils/grid/Xgrid";
import TransitionModal from "../../components/utils/modals/Modals";
// consts
import { seriesDeFeriados as titles } from "../../consts/titulos-de-tablas";
import { modalsInfoSerieDeFeriados as infoModal } from "../../consts/Modals-info";
//Assets
import CircularIndeterminate from '../../components/utils/spinner/Spinner';
//Services 
import { retrieveData } from '../../services/Local-services';
import { feriadosGet } from '../../services/hooli-services/Feriados/FeriadosGet';
import { serieDeFeriadosGet } from '../../services/hooli-services/SerieDeFeriados/SerieDeFeriadosGet';
// recoil
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { formData, rowSelected, userCredentials } from '../../recoilState/GlobalState';

export default function SerieDeFeriados() {
    const [serieDeFeriados, setSerieDeFeriados] = useState([]);
    const [rows, setRows] = useState([]);
    const [feriados, setFeriados] = useState([]);
    const [feriadoSeleccionado, setFeriadoSeleccionado] = useState(1);
    const [action, setAction] = useState({});
    const [cargando, setCargando] = useState(true);

    const setRow = useSetRecoilState(rowSelected)
    const credentials = useRecoilValue(userCredentials);
    const setFormInfo = useSetRecoilState(formData);

    async function retrieveHolidays() {
        const params = { "feriadoId": feriadoSeleccionado }

        const payload = { ...credentials, params };
        setRows([]);
        setCargando(true);

        const data = await serieDeFeriadosGet(payload);

        setCargando(false);
        setSerieDeFeriados(data)
        setRow({ status: false })
    };

    useEffect(() => {
        if (Object.keys(credentials).length > 0) retrieveData(credentials, undefined, feriadosGet, setFeriados)
    }, [credentials])

    useEffect(() => {
        if (Object.keys(credentials).length > 0) retrieveHolidays()
    }, [credentials, feriadoSeleccionado]);

    useEffect(() => {
        serieDeFeriados.map((item) => {
            const {
                feriadoSerieId,
                feriadoSerieVersion,
                feriadoSerieFecha,
                feriadoSerieEsComercial,
                feriadoSerieEsBancario
            } = item

            const serie = {
                id: feriadoSerieId,
                version: feriadoSerieVersion,
                feriadoSerieEsComercial,
                feriadoSerieEsBancario,
                [titles[0]]: feriadoSerieFecha,
                [titles[1]]: feriadoSerieEsComercial === 'Y' ? 'Si' : 'No',
                [titles[2]]: feriadoSerieEsBancario === 'Y' ? 'Si' : 'No',
            }

            setRows(rows => [...rows, serie])
            return item
        })
    }, [serieDeFeriados])

    useEffect(() => setRow({ status: false, row: {}}), []);


    const handleClick = ({ action, procede }) => {
        setAction({ action, procede });
        setFormInfo(infoModal[action]);
    };

    const gridContainer = document.getElementById('grid-container')
    const gridWidth = gridContainer ? gridContainer.offsetWidth : 0;

    return (
        <main>
            <TransitionModal
                titles={titles}
                procede={action.procede}
                feriadoSeleccionado={feriadoSeleccionado}
                updateList={retrieveHolidays}
            />
            <Filtros
                feriados={feriados}
                feriadoSeleccionado={feriadoSeleccionado}
                setFeriadoSeleccionado={setFeriadoSeleccionado}
                handleClick={handleClick}
                cargando={cargando}
                updateList={retrieveHolidays}
            />
            <div className="row-grid" id="grid-container">
                {cargando ? <CircularIndeterminate /> : <XGridDemo rows={rows} titles={titles} indice={0} width={gridWidth} />}
            </div>
        </main>
    )
};